module.exports = __webpack_public_path__ + "static/media/floydIcon.99733aa5.jpg";